import ActionModal from 'asterX-UI/Modals/ActionModal'
import { UserInfo } from 'asterX-UI/DataDisplay'
import { useTranslation } from 'react-i18next'
import { FutureIconContainer, LockedIcon, UnlockedIcon } from 'asterX-UI/Icons'
import React, { useState } from 'react'
import { useResErrors } from 'hooks'
import { AuthService } from 'lib/api'
import { LoaderBackdrop } from 'asterX-UI/Loaders'

const LockUnlockUserModal = ({
  user,
  isActive,
  open = false,
  onClose = () => {},
  onSave = () => {}
}) => {
  const { t } = useTranslation()
  const namespace = 'components.lockUnlockUser.'
  const { standardCheck } = useResErrors()
  const [loading, setLoading] = useState(false)

  const handleSave = async () => {
    setLoading(true)
    await AuthService.blockUser({ id: user?.id, isActive }).then(res =>
      standardCheck(
        res,
        () => {
          setLoading(false)
          onSave && onSave(user, isActive)
        },
        {
          textErr: t(namespace + 'errors.default'),
          onFail: () => setLoading(false)
        }
      )
    )
  }
  return (
    <ActionModal
      open={open}
      color={isActive ? 'primary' : 'secondary'}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={handleSave}
      iconComponent={
        <FutureIconContainer color={isActive ? 'primary' : 'secondary'}>
          {isActive ? <UnlockedIcon /> : <LockedIcon />}
        </FutureIconContainer>
      }
      title={isActive ? t(namespace + 'unlock') : t(namespace + 'lock')}
      labelConfirm={t(namespace + 'confirm')}
    >
      <LoaderBackdrop loading={loading} />
      <UserInfo
        avatar={user?.photo}
        fullName={`${user?.firstName || ''} ${user?.lastName || ''} `}
        phone={user?.phone || ''}
      />
    </ActionModal>
  )
}
export default LockUnlockUserModal
